import React, { useRef } from 'react';
import { Canvas, useFrame, useLoader } from '@react-three/fiber';
import { OrbitControls, Text } from '@react-three/drei';
import * as THREE from 'three';
import earthmap from './textures/earthmap.jpg'

const Earth = () => {
  const earthRef = useRef();

  // Load textures
  const [colorMap, bumpMap] = useLoader(THREE.TextureLoader, [
    earthmap
  ]);

  // Rotate Earth slowly
  useFrame(() => {
    earthRef.current.rotation.y += 0.002;
  });

  return (
    <mesh ref={earthRef} scale={1.5}>
      <sphereGeometry args={[1, 64, 64]} />
      <meshStandardMaterial
        map={colorMap}
        bumpMap={bumpMap}
        bumpScale={0.05}
        metalness={0.4}
        roughness={0.7}
      />
    </mesh>
  );
};

const Hero3D = () => (
  <Canvas style={{ height: '300px' }}>
    <ambientLight intensity={0.5} />
    <directionalLight position={[5, 5, 5]} intensity={1.2} />
    
    <Earth />


    <OrbitControls enableZoom={false} autoRotate autoRotateSpeed={0.5} />
  </Canvas>
);

export default Hero3D;
